// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--ikcw2","prise-type-switch":"_025a50318d--prise-type-switch--R0aBA"};